exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gallery-row{height:200px;width:100%;display:flex;flex-direction:row;flex-wrap:nowrap;align-content:stretch;flex-grow:1;margin-top:.5em}.gallery-row .attachment.image{margin:0 .5em 0 0;flex-grow:1;height:100%;box-sizing:border-box;min-width:2em}.gallery-row .attachment.image:last-child{margin:0}.gallery-row .image-attachment{width:100%;height:100%}.gallery-row .video-container{height:100%}.gallery-row.contain-fit img,.gallery-row.contain-fit video{object-fit:contain}.gallery-row.cover-fit img,.gallery-row.cover-fit video{object-fit:cover}", ""]);

// exports
